import { DpSentrySetUser } from '@docupet/component-library';
import UserService from '@/api/services/UserService';

export const namespaced = true;

export const state = {
  user: {},
  city: {},
  loading: false,
  cityLoading: false,
};

export const mutations = {
  LOADING(state, loading) {
    state.loading = loading;
  },
  SET_USER(state, user) {
    state.user = user;
    if (user) {
      DpSentrySetUser(user?.id, user?.email);
    }
  },
  CITYLOADING(state, loading) {
    state.cityLoading = loading;
  },
  SET_CITY(state, city) {
    state.city = city;
  },
};

export const actions = {
  fetchUser({ commit, dispatch }) {
    commit('LOADING', true);
    UserService.getUser()
      .then((response) => {
        commit('SET_USER', response);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('LOADING', false);
        error.location = 'fetchUser';
        dispatch(
          'notification/notifyFailure',
          { message: 'Fail to retrieve your user info.', options: { dismissSecs: 15 } },
          { root: true }
        );
      });
  },
  fetchCity({ commit, dispatch }, { cityId }) {
    commit('CITYLOADING', true);
    UserService.fetchCity(cityId)
      .then((response) => {
        commit('SET_CITY', response);
        commit('CITYLOADING', false);
      })
      .catch((error) => {
        commit('CITYLOADING', false);
        error.location = 'fetchCity';
        dispatch('notification/notifyFailure', { message: 'Fail to retrieve city info.', options: { dismissSecs: 15 } }, { root: true });
      });
  },
};

export const getters = {
  showHomePage: (state) => (!state.cityLoading ? state.city?.showStoreHomePage : true),
  isPetOwner: (state) => state.user?.__typename === 'PetOwner',
  petMembershipsEnabled: (state) => state.user?.city?.petMembershipsEnabled ?? state.city?.petMembershipsEnabled ?? false,
  plusActivePetNames: (state) =>
    (state.user?.pets || [])
      .filter((pet) => pet.plusMembershipActive)
      .map((pet) => pet.name)
      .filter((name) => !!name),
  hasUpsellEligiblePet: (state) => (state.user?.pets || []).some((pet) => pet.plusUpsellEligible),
};
